module.exports = __webpack_public_path__ + "img/macbook_gold-1.685b81be.png";